module.exports = __webpack_public_path__ + "static/media/rectangle-3.2e49a264.svg";